import { render, staticRenderFns } from "./Poems.vue?vue&type=template&id=22bffc69&"
import script from "./Poems.vue?vue&type=script&lang=js&"
export * from "./Poems.vue?vue&type=script&lang=js&"
import style0 from "./Poems.vue?vue&type=style&index=0&id=22bffc69&prod&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports